<template>
<!-- 医生详情组件 -->
  <div id="doctor-detail" @click="test">
    <div class="see-doctor" >
      <div class="see-title" v-show="titleFlag && isShowTilte" @click="goDoctorSearch">
        <span class="title-name">看病就医</span>
        <img src="../../assets/img/see-doctor-icon/1-3xiayibu@2x.png" alt="" class="more-icon">
      </div>
      <div class="doctor-detail"  @click="goRouter('/SdDoctorMsg',doctorData.doctor_id)">
        <div class="doctor-left">
          <img src="../../assets/img/see-doctor-icon/1-3tuijian@2x.png" alt="" class="good-icon" v-if="doctorData.is_famous_doctor !== 'n'">
          <img :src="doctorData.image" alt="" class="doctor-icon">
          <img src="../../assets/img/see-doctor-icon/good-doctor@2x.png" alt="" class="good-doc" v-if="doctorData.is_famous_doctor !== 'n'">
        </div>
        <div class="doctor-msg">
          <div class="doctor-name">
            <span class="name-text">{{doctorData.name}}</span>
            <span class="doc-level">{{doctorData.clinic_name}}</span>
            <span class="doc-level">{{doctorData.title}}</span>
            <!-- <img src="../../assets/img/see-doctor-icon/1-3mingyi@2x.png" alt="" class="good-tips"> -->
          </div>
          <div class="doctor-hospital">
            <span class="hospital-text">{{doctorData.hospital}}</span>
          </div>
          <ul class="doctor-tips">
            <!-- <li class="tips-text" v-for="(item,index) in doctorData.tags" :key="index"> -->
            <li class="tips-text"  v-for="(item,index) in doctorData.tags" :key="index">
              <span>{{item}}</span>
            </li>
          </ul>
          <span class="doctor-skil">擅长:{{doctorData.good_at}}</span>
          <div class="doctor-hot">
            <span class="hot-text">咨询人次
              <span class="hot-number">{{doctorData.reply_num}}次</span>
            </span>
            <span class="hot-text hot-tag">|</span>
            <span class="hot-text">好评率
              <span class="hot-number">{{doctorData.good_rate}}%</span>
            </span>
          </div>
          <div class="doctor-ask">
            <span class="ask-price">￥{{doctorData.price/100}}元/次</span>
            <van-button type='primary' @click.stop="goAsk(item)" class="ask-button">咨询</van-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      doctorData: {},
      titleFlag: false
    }
  },
  props: {
    isShowTilte: {
      type: Boolean ,
      default: true 
    },
    departmentId: {},
    group_id: '',
    item: {
      type: Object
    },
    doctor_id: ''
  },
  watch: {
    // departmentId (n, o) {
    //   this.fetch()
    // },
    group_id (n, o) {
      this.fetch()
    },
    doctor_id: {
      handler (n, o) {
        this.fetch()
      }
    },
    item: {
      handler (n, o) {
        this.doctorData = n
      },
      deep: true
    }
  },
  beforeMount () {
    if (this.item) {
      this.doctorData = this.item
    }
    if (this.$route.path === '/SdDetailVideo' || this.$route.path === '/SdGroupDetail') {
      this.titleFlag = true
    } else {
      this.titleFlag = false
    }
  },
  methods: {
    test () {
    },
    fetch () {
      let params = {
        group_id: this.group_id
      }
      let url = `/home/video_detail_recommend?group_id=${
        params.group_id
      }`
      this.$http.get(url).then(res => {
        if (res.data.code == '0' || res.data.code == 0) {
          this.doctorData = res.data.data
        } else {
          this.$toast(res.data.message)
        }
      })
    },
    goRouter (val, id) {
      this.$router.push({ path: val, query: { doctorId: id } })
    },
    goDoctorSearch () {
      let params = this.doctorData
      this.$router.push({
        path: '/SdAskDoctor',
        query: { name: params.clinic_name, department_id: params.department_id }
      })
    },
    goAsk (val) {
      this.$router.push({path: '/SdInquiry', query: {from: this.$route.fullPath, doctor_id: this.doctorData.doctor_id}})
    }
  }
}
</script>

<style lang="postcss">
#doctor-detail {
  background-color: #fffffd;
  height: 100%;
  & .see-doctor {
    margin-top: 50px;
    & .see-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      & .title-name {
        font-size: 36px;
        font-family: SourceHanSansCN-Bold;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
      }
      & .more-icon {
        width: 15px;
        height: 29px;
      }
    }
    & .doctor-detail::after {
          position: absolute;
          bottom: 0;
          content: '';
          display: block;
          width: 100%;
          height: 1px;
          border: 1px solid rgba(215, 215, 215, 1);
          transform: scaleY(.3);
        }
    & .doctor-detail {
      position: relative;
      margin-top: 30px;
      display: flex;
      padding-bottom: 30px;
      & .doctor-left {
        width: 180px;
        position: relative;
        margin-right: 30px;
        & .doctor-icon {
          width: 120px;
          height: 120px;
          z-index: 666;
          position: absolute;
          border-radius: 50%;
          border: 1px solid #ddd;
        }
        & .good-icon {
          position: absolute;
          width: 53px;
          height: 72px;
          left: -10px;
          top: -30px;
          z-index: 555;
        }
        & .good-doc {
          width: 120px;
          height: 41px;
          position: absolute;
          top: 100px;
          z-index: 777;
        }
      }
      & .doctor-msg {
        width: 100%;
        & .doctor-name {
          & .name-text {
            font-size: 30px;
            font-family: SourceHanSansCN-Medium;
            font-weight: bold;
            color: rgba(51, 51, 51, 1);
            margin-right: 10px;
          }
          & .doc-level {
            font-size: 26px;
            font-family: SourceHanSansCN-Regular;
            font-weight: 400;
            color: rgba(153, 153, 153, 1);
            /* margin-left: 20px; */
          }
          & .good-tips {
            width: 48px;
            height: 28px;
          }
        }
        & .doctor-hospital {
          margin: 10px 0;
          & .hospital-text {
            font-size: 26px;
            font-family: SourceHanSansCN-Regular;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
          }
          & .doc-text {
            font-size: 26px;
            font-family: SourceHanSansCN-Regular;
            font-weight: 400;
            color: rgba(153, 153, 153, 1);
            margin-left: 21px;
          }
        }
        & .doctor-skil {
          display: inline-block;
          width: 488px;
          font-size: 24px;
          font-family: SourceHanSansCN-Regular;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          line-height: 38px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: box;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          /*! autoprefixer: off */
          -webkit-box-orient: vertical;
          /* autoprefixer: on */
        }
        & .doctor-tips {
          display: flex;
          flex-wrap: nowrap;
          font-size: 20px;
          font-family: SourceHanSansCN-Regular;
          font-weight: 400;
          color: rgba(55, 189, 25, 1);
          margin: 10px 0;
          width: 100%;
          & .tips-text {
            background: rgba(55, 189, 25, 0.1);
            border-radius: 15px;
            padding: 5px 10px;
            margin-right: 20px;
          }
        }
        & .doctor-hot {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin: 30px 0;
          border-bottom: 1px solid rgba(215, 215, 215, 0.6);
          padding-bottom: 30px;
          & .hot-text {
            display: flex;
            flex-wrap: nowrap;
            display: flex;
            align-items: center;
            font-size: 24px;
            font-family: SourceHanSansCN-Regular;
            font-weight: 400;
            color: rgba(153, 153, 153, 1);
            margin-right: 30px;
            & .hot-number {
              font-size: 32px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: rgba(102, 102, 102, 1);
              margin-left: 10px;
            }
          }
          & .hot-tag {
            margin-right: 30px;
            color: rgba(215, 215, 215, 1);
          }
        }
        & .doctor-ask {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 30px;
          font-family: SourceHanSansCN-Medium;
          font-weight: 500;
          color: rgba(244, 160, 0, 1);
          & .ask-button {
            line-height: 44px;
            width: 144px;
            height: 44px;
            background: rgba(55, 189, 25, 1);
            border-radius: 22px;
            font-size: 28px;
            font-family: SourceHanSansCN-Medium;
            font-weight: 500;
            color: rgba(255, 255, 255, 1);
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/DoctorDetail.vue